import { CurrencyPipe, DecimalPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MostPopular } from '@zero/asset-class-overview/domain';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { InstrumentDetailsLinkComponent } from '@zero/shared/ui-web-components';
import { IconButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';
import { InstrumentType } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'shared-most-famous-assets',
  imports: [
    TranslocoPipe,
    IconButtonComponent,
    IconComponent,
    InstrumentDetailsLinkComponent,
    NgTemplateOutlet,
    BlinkDirective,
    CurrencyPipe,
    NgClass,
    DecimalPipe,
  ],
  templateUrl: './most-famous-assets.component.html',
  styleUrl: './most-famous-assets.component.scss',
})
export class MostFamousAssetsComponent {
  public readonly collapsed = signal<boolean>(false);
  public readonly commonRoutes = commonRoutes;
  public instruments = input<MostPopular>();
  public type = input<InstrumentType>();

  public collapse = () => this.collapsed.update((collapsed) => !collapsed);
}
